// src/features/audit/components/AuditWorkspaceHeader.tsx
import { Card, formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import type { AuditRecord } from '../data/audit.mock';
import { AuditStatusBadge } from './AuditStatusBadge';

export interface AuditWorkspaceHeaderProps {
  record: AuditRecord;
}

/**
 * Top-of-page header for the audit workspace. Same glass Card surface
 * as every other card here, but laid out as identity (event title +
 * status badge) plus a small meta list (id, actor, last recorded
 * time) on one side and a reserved action area on the other. The
 * action button is disabled and non-functional, same placeholder
 * pattern as SecurityWorkspaceHeader / CommissionWorkspaceHeader —
 * real workspace actions (flag record, escalate, etc.) are a later
 * phase.
 */
export function AuditWorkspaceHeader({ record }: AuditWorkspaceHeaderProps) {
  return (
    <Card className="vania-audit-workspace-header">
      <div className="vania-audit-workspace-header-main">
        <div className="vania-audit-workspace-header-identity">
          <h1 className="vania-audit-workspace-name">{record.eventTitle}</h1>
          <AuditStatusBadge status={record.status} />
        </div>

        <dl className="vania-audit-workspace-meta">
          <div>
            <dt>شناسه رخداد</dt>
            <dd dir="ltr">{formatPersianNumber(record.id)}</dd>
          </div>
          <div>
            <dt>کاربر انجام‌دهنده</dt>
            <dd>{record.actorName}</dd>
          </div>
          <div>
            <dt>زمان ثبت</dt>
            <dd dir="ltr">{formatSolarDate(record.timestamp)}</dd>
          </div>
        </dl>
      </div>

      <div className="vania-audit-workspace-header-actions">
        <button
          type="button"
          disabled
          className="vania-audit-action-placeholder"
          title="در فاز بعدی فعال می‌شود"
        >
          عملیات رخداد
        </button>
      </div>
    </Card>
  );
}
